

















































































































































































































/* 
  saveOrUpdate 保存或编辑教师信息
*/
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Form as ElForm } from "element-ui";
import { validateMax32, validateAge,validateTeacherAge, blurTeacherAge, ruleNormal, rulePattern,validatePhone } from '@/utils/regxCustom'
import {
  saveOrUpdate,
  getTeacherInfoByCardId,
  addTeacherInfo,
  checkCanEdit
} from "../../../../api/teacherInfoManage";
import {
  computedDate
} from "../../../../utils/common";

@Component({
  name: "teacherInfoManageDetail"
})
export default class extends Vue {
  @Prop(String) type!: string;
  @Prop(Object) private teacherInfo!: {
    otherinfoSourceId: "";
    otherinfoProjectId: "";
    teacherName: "";
    teacherGenderId: "";
    teacherCard: "";
    teacherBirthday: "";
    teacherAge: "";
    teacherProfessionalId: "";
    teacherTeachingAge: "";
    teacherGradeId: "";
    otherinfoSubject: "";
    teacherPhone: "";
    teacherDistrictId: "";
    teacherSchoolId: "";
    otherinfoIsRecommendValue: "";
    otherinfoIsRecommend: "";
  };

  private fullscreenLoading: boolean = false; //spin toggle

  private editForm: Object = {};

  private dialogFormTitle: string = ""; //弹窗标题
  private editFormRules: object = {
    otherinfoSourceId: [ruleNormal("请选择来源")],
    otherinfoProjectId: [ruleNormal("请选择项目")],
    teacherName: [
      ruleNormal("请输入姓名"),
      { validator: validateMax32 }
    ],
    // teacherGenderId: [ruleNormal("请选择性别")],
    teacherCard: [
      ruleNormal("请输入身份证号")
    ],
    // teacherBirthday: [ruleNormal("请选择出生日期")],
    teacherAge: [
      ruleNormal("请输入年龄"),
      { validator: validateAge }
    ],
    // teacherProfessionalId: [ruleNormal("请选择职称")],
    teacherTeachingAge: [
      ruleNormal("请输入教龄"),
      { validator: validateTeacherAge },
      { validator: blurTeacherAge, trigger: "blur" }
    ],
    // teacherGradeId: [ruleNormal("请选择任课年级")],
    otherinfoSubject: [ruleNormal("请选择科目")], // 这里有问题
    teacherPhone: [
      ruleNormal("请输入手机号码"),
      //  { validator: validatePhone }
    ],
    teacherDistrictId: [ruleNormal("请选择所属市县")],
    teacherSchoolId: [ruleNormal("请选择所属单位")]
  };

  created() {
    if (this.type === "add") {
      this.dialogFormTitle = "添加教师";
    } else if (this.type === "modify") {
      this.dialogFormTitle = "修改教师";
    }
  }

  // 根据是否推荐显示value，但是传给后台传递数字
  private ifRecommend(e) {
    if (e !== "") {
      this.editForm[`otherinfoIsRecommendValue`] = e == "0" ? "是" : "否";
    } else {
      this.editForm[`otherinfoIsRecommendValue`] = null;
    }
    this.editForm[`otherinfoIsRecommend`] = e;
  }

  // 根据选择的市县过滤单位列表
  get filteredSchools(): any[] {
    const schools = (this.$parent as any).schools || [];
    if (!this.editForm[`teacherDistrictId`]) {
      return schools;
    }
    return schools.filter((school: any) => school.schoolDistrictId === this.editForm[`teacherDistrictId`]);
  }

  // 市县变更时清空单位选择
  private handleDistrictChange() {
    this.editForm[`teacherSchoolId`] = '';
  }

  // 监听 teacherInfo 变化，同步更新 editForm
  @Watch("teacherInfo", { immediate: true, deep: true })
  private onTeacherInfoChange(val: any) {
    if (val) {
      this.editForm = {
        otherinfoSourceId: val.otherinfoSourceId || "",
        otherinfoProjectId: this.$parent['projectId'] || val.otherinfoProjectId || "",
        teacherName: val.teacherName || "",
        teacherGenderId: val.teacherGenderId || "",
        teacherCard: val.teacherCard || "",
        teacherBirthday: val.teacherBirthday || "",
        teacherAge: val.teacherAge || "",
        teacherProfessionalId: val.teacherProfessionalId || "",
        teacherTeachingAge: val.teacherTeachingAge || "",
        teacherGradeId: val.teacherGradeId || "",
        otherinfoSubject: val.otherinfoSubject || "",
        teacherPhone: val.teacherPhone || "",
        teacherDistrictId: val.teacherDistrictId || "",
        teacherSchoolId: val.teacherSchoolId || "",
        otherinfoIsRecommendValue: val.otherinfoIsRecommendValue || "",
        otherinfoIsRecommend: String(val.otherinfoIsRecommend) || "",
      };
      // 解决打开弹窗就对科目进行非空校验的问题
      if (!val.otherinfoSubject) {
        this.$set(this.editForm, 'otherinfoSubject', []);
      }
    }
  }
  // form 表单正则之外的校验 res = {age:'', bornDate:'',gender:''} 1 男 2 女

  private async handleID(val) {
    let data = await getTeacherInfoByCardId(val); //输入完身份证，通过格式校验发送请求获取当前身份证用户的信息
    if (data.data) {
      // 弹窗提示黑名单用户是否继续添加，取消则隐藏弹窗
      if (data.data[`teacherIsBlacklist`] == "1") {
        this.$confirm('此教师在黑名单中, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {}).catch(() => {
          (this.$parent as any).dialogFormVisible = false;  //取消则隐藏弹窗
          this.$message({
            type: 'info',
            message: '已取消添加'
          });
        });
      }
      //如果存在则自动填充
      this.editForm[`teacherName`] = data.data[`teacherName`];
      this.editForm[`teacherAge`] = data.data[`teacherAge`];
      this.editForm[`teacherName`] = data.data[`teacherName`];
      this.editForm[`teacherProfessionalId`] =
        data.data[`teacherProfessionalId`];
      this.editForm[`teacherTeachingAge`] = data.data[`teacherTeachingAge`];
      this.editForm[`teacherGradeId`] = data.data[`teacherGradeId`];
      this.editForm[`teacherPhone`] = data.data[`teacherPhone`];
      this.editForm[`teacherSchoolId`] = data.data[`teacherSchoolId`];
    } else {
      //如果删除身份证号码则清空其他数据(除了 来源 项目 科目 身份证号)
      for (let key in this.editForm) {
        if (
          key === "teacherCard" ||
          key === "otherinfoSourceId" ||
          key === "otherinfoProjectId" ||
          key === "otherinfoSubject"
        ) {
          continue;
        }
        this.editForm[key] = "";
      }
    }
    // 格式校验
    let IDReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    let res = computedDate(val);
    if (!IDReg.test(val)) {
      this.$message.warning("请检查身份证号码是否有误！");
    } else {
      if (
        this.editForm[`teacherGenderId`] &&
        this.editForm[`teacherGenderId`] != res.gender
      ) {
        this.$message.warning("请检查性别和身份证号码是否一致！");
      }

      this.editForm[`teacherGenderId`] = res.gender;
      if (
        this.editForm[`teacherBirthday`] &&
        this.editForm[`teacherBirthday`] != res.bornDate
      ) {
        this.$message.warning("请检查出生日期和身份证号码是否一致！");
      }
      this.editForm[`teacherBirthday`] = res.bornDate;

      if (
        this.editForm[`teacherAge`] &&
        this.editForm[`teacherAge`] != res.age
      ) {
        this.$message.warning("请检查年龄和身份证号码是否一致！");
      }
      this.editForm[`teacherAge`] = res.age;
    }
    this.$forceUpdate();
  }

  // 性别
  private handleGender(val) {
    let IDReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (
      this.editForm[`teacherGenderId`] &&
      IDReg.test(this.editForm[`teacherCard`])
    ) {
      let res = computedDate(this.editForm[`teacherCard`]);
      this.editForm[`teacherGenderId`] != res.gender
        ? this.$message.warning("请检查性别和身份证号是否一致！")
        : "";
      this.editForm[`teacherGenderId`] = val;
    }
    this.$forceUpdate();
  }
  // 出生日期
  private handleBirthday(val) {
    let IDReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (
      this.editForm[`teacherBirthday`] &&
      IDReg.test(this.editForm[`teacherCard`])
    ) {
      let res = computedDate(this.editForm[`teacherCard`]);
      this.editForm[`teacherBirthday`] != res.bornDate
        ? this.$message.warning("请检查生日和身份证号是否一致！")
        : "";
      this.editForm[`teacherBirthday`] = val;
    }
    this.$forceUpdate();
  }

  // 年级
  private handleAge(val) {
    let IDReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (
      this.editForm[`teacherAge`] &&
      IDReg.test(this.editForm[`teacherCard`])
    ) {
      let res = computedDate(this.editForm[`teacherCard`]);
      this.editForm[`teacherAge`] != res.age
        ? this.$message.warning("请检查年龄和身份证号是否一致！")
        : "";
      this.editForm[`teacherAge`] = val;
    }
    this.editForm[`teacherAge`] = val;
    this.$forceUpdate();
  }

  // 保存或编辑
  private saveEditHandle() {
    (this.$refs.editForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        // 修改时必须选择项目
        if (this.type === "modify" && !this.editForm[`otherinfoProjectId`]) {
          this.$message.warning("修改教师信息必须先选择项目");
          return;
        }
        //清除undefined字符串
        for(let key in this.editForm) {
          if(typeof this.editForm[key] == 'string' &&
          this.editForm[key] == 'undefined'
          && key !== 'teacherName') {
            this.editForm[key] = ''
          }
        }
        try {
          this.fullscreenLoading = true;

          // 修改时检查审核状态
          if (this.type === "modify") {
            if (!this.editForm['teacherId']) {
              this.$message.error('教师ID缺失，无法修改');
              this.fullscreenLoading = false;
              return;
            }
            try {
              const checkRes = await checkCanEdit(
                this.editForm[`teacherId`],
                this.editForm[`otherinfoProjectId`]
              );
              if (!checkRes.data) {
                this.$message.error("该教师信息已有审核通过，不允许修改");
                this.fullscreenLoading = false;
                return;
              }
            } catch (e) {
              // 检查接口失败，拦截保存
              this.$message.error("审核状态检查失败，无法保存");
              this.fullscreenLoading = false;
              return;
            }
          }

          let res =
            this.type === "modify"
              ? await saveOrUpdate(this.editForm)
              : await addTeacherInfo(this.editForm);
          this.fullscreenLoading = false;
          this.$message.success("保存成功");
          //关闭弹窗
          (this.$parent as any).dialogFormVisible = false;
          //刷新列表
          (this.$parent as any).getData();
          (this.$refs.editForm as ElForm).clearValidate();
        } catch (error) {
          this.fullscreenLoading = false;
          // this.$message.error(error || "保存失败");
          this[`$message`]({
            type: "error",
            message: error!.mesg ? error!.mesg : error
          });
        }
      }
    });
  }

  // 取消
  private handleCancel() {
    (this.$refs.editForm as ElForm).clearValidate();
    (this.$parent as any).dialogFormVisible = false;
  }
}
